<template>
  <v-app-bar elevate-on-scroll app color="rgba(250,250,250)" class="font-weight-bold" style="z-index: 10;">
    <v-container class="mr-0">
      <v-row class="text-center" align="center" justify="end" v-scroll-spy-active="{selector: '.btn-txt', class: 'highlighted'}">
        <v-col cols="auto" class="btn">
          <div class="btn-txt" @click="goTo('#hero')">
            Home
          </div>
        </v-col>

        <v-col cols="auto" class="btn">
          <div class="btn-txt" @click="goTo('#about')">
            About
          </div>
        </v-col>

        <v-col cols="auto" class="btn">
          <div class="btn-txt" @click="goTo('#services')">
            Services
          </div>
        </v-col>

        <v-col cols="auto" class="btn">
          <div class="btn-txt" @click="goTo('#skills')">
            Skills
          </div>
        </v-col>

        <v-col cols="auto" class="btn">
          <div class="btn-txt" @click="goTo('#experiences')">
            Experiences
          </div>
        </v-col>

        <v-col cols="auto" class="btn">
          <div class="btn-txt"  @click="goTo('#portfolio')">
            Portfolio
          </div>
        </v-col>

        <!--<v-col cols="auto">
          <div :class="'btn ' + ('/' === $route.path ? 'highlighted' : '')" @click="goTo('#pricing')">
            Pricing
          </div>
        </v-col>-->

        <!--<v-col cols="auto">
          <div :class="'btn ' + ('/' === $route.path ? 'highlighted' : '')" @click="goTo('#blog')">
            Blog
          </div>
        </v-col>-->

        <v-col cols="auto" class="btn">
          <div class="btn-txt" @click="goTo('#contact')">
            Contact
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
/**
 * ! Use ScrollSpy for vue to make an automatic update of the navbar depending on which anchor is in the view
 */
export default {
  methods: {
    goTo (anchor) {
      this.$vuetify.goTo(anchor)
    }
  }
}
</script>

<style lang="scss">
.btn {
  text-align: center;
  padding: 10px 20px;
}
.btn-txt {
  cursor: pointer;
  color: #24305e;
  transition: 0.4s;

  &:hover {
    color: #f76c6c;
  }
}

.highlighted {
  border-bottom: 2px solid black;
}
</style>
